// jQuery
import './utils/polyfill-nodelist-foreach';
import './utils/jquery';
import $ from 'jquery';
import './polyfills/nodeListForEach';
import $script from 'scriptjs';

import flickityTouchFix from './helpers/FlickityTouchFix';

import 'intersection-observer';
import PxsMap from 'pxs-map';
import PxsVideo from 'pxs-video';
import rimg from 'rimg-shopify';
import ShopifySectionsManager from 'shopify-sections-manager';

// Sections
import Collection from './sections/Collection';
import DynamicSlideshow from './sections/DynamicSlideshow';
import DynamicSocialWidgets from './sections/DynamicSocialWidgets';
import Product from './sections/Product';
import StaticAddresses from './sections/StaticAddresses';
import StaticBlog from './sections/StaticBlog';
import StaticGiftCard from './sections/StaticGiftCard';
import StaticHeader from './sections/StaticHeader';
import StaticPassword from './sections/StaticPassword';
import StaticCart from './sections/StaticCart';
import StaticProductRecommendations from './sections/StaticProductRecommendations';

// Components
import ProductList from './components/ProductList';
import Rte from './utils/Rte';
import Select from './components/Select';
import Share from './components/Share';

class Editions {
  constructor() {
    rimg.init();

    this.$el = $(document.body);
    this.sections = new ShopifySectionsManager();

    this.sections.register('dynamic-featured-collection', section => new Collection(section));
    this.sections.register('dynamic-featured-product', section => new Product(section));
    this.sections.register('dynamic-slideshow', section => new DynamicSlideshow(section));
    this.sections.register('dynamic-social-widgets', section => new DynamicSocialWidgets(section));
    this.sections.register('pxs-map', section => new PxsMap(section));
    this.sections.register('pxs-video', section => new PxsVideo(section));
    this.sections.register('static-addresses', section => new StaticAddresses(section));
    this.sections.register('static-article', section => new Share(section));
    this.sections.register('static-blog', section => new StaticBlog(section));
    this.sections.register('static-collection', section => new Collection(section));
    this.sections.register('static-giftcard', section => new StaticGiftCard(section));
    this.sections.register('static-header', section => new StaticHeader(section));
    this.sections.register('static-password', section => new StaticPassword(section));
    this.sections.register('static-product', section => new Product(section));
    this.sections.register('static-product-recommendations', section => new StaticProductRecommendations(section));
    this.sections.register('static-search-results', section => new ProductList(section));
    this.sections.register('static-cart', section => new StaticCart(section));

    $('.rte').each((index, rte) => new Rte({ el: rte }));
    $('select').each((index, select) => new Select({ el: select }));

    flickityTouchFix();
  }
}

const scripts = $('[data-scripts]');

$script([scripts.data('shopify-api-url')], () => {
  window.theme = new Editions();
});
